<template>
  <d2-container></d2-container>
</template>
<script>
export default {
  name: 'lotteryTestManger',
  data () {
    return {}
  },
  created () {
  },
  methods: {

  }
}
</script>
<style scoped>
</style>
